export default __webpack_public_path__ + "static/KeywordResearch_02_02-3e22ebcac5c589dc9f296d864c3f7bcc.png";